export default __webpack_public_path__ + "static/media/instagram.5da5b337.svg";